export const transformSeasons = (season: any) => ({
  Title: season?.title || '',
  Id: season?.id || '',
});
